import { useMemo } from 'react';
import type { ColumnDef } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import type { LogicTypeTargetWorkspaceWriteModel } from '@r/api/generated/client.schemas.ts';
import type { TargetLogicType } from '@admin/types/workspace/logic.ts';
import { LOGIC_TRANSLATION_KEYS } from '@admin/types/workspace/logic.ts';
import { LogicLogicReadModelType } from '@r/api/generated/client.schemas.ts';

type Target = LogicTypeTargetWorkspaceWriteModel & {
  logicTargetType?: TargetLogicType;
};

export const useTargetColumns = (): ColumnDef<Target>[] => {
  const { t } = useTranslation();

  const logicTranslations = useMemo(() => {
    return {
      [LogicLogicReadModelType.TARGET_PERF]: t(
        LOGIC_TRANSLATION_KEYS[LogicLogicReadModelType.TARGET_PERF]
      ),
      [LogicLogicReadModelType.TARGET_POINT]: t(
        LOGIC_TRANSLATION_KEYS[LogicLogicReadModelType.TARGET_POINT]
      )
    };
  }, [t]);

  return [
    {
      accessorKey: 'reference',
      header: t('form.target.reference.label')
    },
    {
      accessorKey: 'description',
      header: t('form.target.description.label'),
      cell: ({ row }) => {
        return row.original.description;
      }
    },
    {
      accessorKey: 'logicTargetType',
      header: t('form.target.type.label'),
      cell: ({ row }) => {
        const type = row.original.logicTargetType;
        if (!type) return '-';
        return logicTranslations[type] || '-';
      }
    }
  ];
};
